import Alpine from 'alpinejs';
import './jobs';
import './cookies';

window.Alpine = Alpine;
